import { useState } from "react";
import { useNavigate } from "react-router-dom";

const API = process.env.REACT_APP_API_URL || "http://localhost:5000";

function Login() {
  const [isLogin, setIsLogin] = useState(true);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [msg, setMsg] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async () => {
    setLoading(true);
    const url = isLogin ? `${API}/api/login` : `${API}/api/register`;
    const body = isLogin ? { email, password } : { name, email, password };
    try {
      const res = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      });
      const data = await res.json();
      if (data.token) {
        localStorage.setItem("token", data.token);
        localStorage.setItem("name", data.name);
        localStorage.setItem("role", data.role);
        setMsg("Welcome " + data.name + "!");
        setTimeout(() => navigate(data.role === "admin" ? "/admin" : "/"), 1200);
      } else if (data.message) {
        setMsg("Registered! Now login.");
        setIsLogin(true);
      } else {
        setMsg("Error: " + (data.error || "Something went wrong!"));
      }
    } catch {
      setMsg("Server error!");
    }
    setLoading(false);
  };

  const inp = {
    width: "100%", padding: "12px 14px", marginBottom: "12px",
    border: "1.5px solid #e5e7eb", borderRadius: "8px",
    fontFamily: "'Inter',sans-serif", fontSize: "14px", boxSizing: "border-box",
  };

  return (
    <div style={{ minHeight: "100vh", display: "flex", justifyContent: "center",
      alignItems: "center", background: "#f8f9fa", paddingTop: "64px" }}>
      <div style={{ background: "white", border: "1px solid #e5e7eb", padding: "40px 36px",
        borderRadius: "16px", width: "100%", maxWidth: "420px", textAlign: "center",
        margin: "20px", boxShadow: "0 4px 20px rgba(0,0,0,0.08)" }}>

        <div style={{ fontSize: "32px", marginBottom: "12px" }}>👋</div>
        <h2 style={{ fontFamily: "'Poppins',sans-serif", fontSize: "24px", fontWeight: "800",
          color: "#1a1a1a", marginBottom: "6px" }}>
          {isLogin ? "Welcome Back!" : "Join TechSphere"}
        </h2>
        <p style={{ color: "#6b7280", fontSize: "14px", marginBottom: "28px" }}>
          {isLogin ? "Login to access your courses" : "Create your free account today"}
        </p>

        {!isLogin && (
          <input type="text" placeholder="Full Name" value={name}
            onChange={(e) => setName(e.target.value)} style={inp} />
        )}
        <input type="email" placeholder="Email Address" value={email}
          onChange={(e) => setEmail(e.target.value)} style={inp} />
        <input type="password" placeholder="Password" value={password}
          onChange={(e) => setPassword(e.target.value)} style={{ ...inp, marginBottom: "20px" }} />

        <button onClick={handleSubmit} disabled={loading}
          style={{ width: "100%", padding: "13px", background: "#0056D2", color: "white",
            border: "none", borderRadius: "8px", fontWeight: "700", fontSize: "15px",
            cursor: "pointer", fontFamily: "'Inter',sans-serif", marginBottom: "15px" }}>
          {loading ? "Please wait..." : isLogin ? "Login" : "Create Account"}
        </button>

        {msg && (
          <p style={{ color: msg.includes("Error") || msg.includes("error") ? "#dc2626" : "#16a34a",
            fontSize: "14px", marginBottom: "12px" }}>{msg}</p>
        )}

        <p style={{ color: "#6b7280", fontSize: "14px" }}>
          {isLogin ? "New here? " : "Already have account? "}
          <span onClick={() => { setIsLogin(!isLogin); setMsg(""); }}
            style={{ color: "#0056D2", fontWeight: "700", cursor: "pointer" }}>
            {isLogin ? "Register" : "Login"}
          </span>
        </p>
      </div>
    </div>
  );
}
export default Login;
